import React from 'react';
import { Header } from './Header';
import { Footer } from './Footer';
interface LayoutProps {
  children: React.ReactNode;
}
export function Layout({
  children
}: LayoutProps) {
  return <div className="flex flex-col min-h-screen bg-neutral-offwhite" data-id="element-216">
      <Header data-id="element-217" />
      <main className="flex-grow" data-id="element-218">{children}</main>
      <Footer data-id="element-219" />
    </div>;
}